import { styles as componentStyles } from './view.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${flexboxHelpersStyles}`), unsafeCSS(`${componentStyles}`)];
